import { _values, arrayIncludesAll, exists } from '@nu-art/ts-common';
import { EnumeratedVarLogic, getAtomType, getExpressionType, getValueType, Logic_BooleanOperators, LogicType_Exists, LogicType_NotExists, LogicType_In, LogicType_IsChiefComplaint, LogicType_Self, NormalRangeVarLogic, NumericVarLogic, RangeVarLogic, TupleVarLogic, } from '@app/hcs-shared/expression';
import { ModuleFE_Expression, ModuleFE_Variable } from '../../../../../../_entity.js';
const getFilteredBase = (operators, operatorsToFilter) => operators.filter(logic => !operatorsToFilter?.includes(logic));
export const getExpressionQueryFilter = (expressionId, item, mappers, operatorsToFilter) => {
    const expressionType = getExpressionType(expressionId, mappers.expressionMap);
    switch (expressionType) {
        case 'boolean': {
            return getFilteredBase(TupleVarLogic, operatorsToFilter).includes(item);
        }
        case 'numeric': {
            return getFilteredBase(NumericVarLogic, operatorsToFilter).includes(item);
        }
        case 'range':
            return getFilteredBase(RangeVarLogic, operatorsToFilter).includes(item);
        default:
            return true;
    }
};
export const getValueQueryFilter = (leftHand, item, mappers, operatorsToFilter) => {
    const valType = getValueType(leftHand, mappers.variableMap, mappers.valueMap);
    switch (valType) {
        case 'sub-enumerated':
        case 'enumerated': {
            return getFilteredBase(EnumeratedVarLogic, operatorsToFilter).includes(item);
        }
        case 'tuple': {
            return getFilteredBase(TupleVarLogic, operatorsToFilter).includes(item);
        }
        case 'standard-range':
            return getFilteredBase(NormalRangeVarLogic, operatorsToFilter).includes(item);
        case 'range':
            return getFilteredBase(NumericVarLogic, operatorsToFilter).includes(item);
        case 'time':
            return getFilteredBase([LogicType_In], operatorsToFilter).includes(item);
        default:
            return true;
    }
};
export const getAtomQueryFilter = (atom, item, mappers, operatorsToFilter) => {
    const atomType = getAtomType(atom, mappers.variableMap, mappers.valueMap);
    const unusedInSubTerms = [LogicType_Self, LogicType_Exists, LogicType_NotExists, LogicType_IsChiefComplaint];
    switch (atomType) {
        case 'numeric':
            return getFilteredBase(NumericVarLogic.filter(logic => !unusedInSubTerms.includes(logic)), operatorsToFilter).includes(item);
        case 'range':
            return getFilteredBase(RangeVarLogic, operatorsToFilter).includes(item);
        case 'boolean':
            return getFilteredBase(Logic_BooleanOperators.filter(logic => !unusedInSubTerms.includes(logic)), operatorsToFilter).includes(item);
        case 'enum':
            return getFilteredBase(EnumeratedVarLogic.filter(logic => !unusedInSubTerms.includes(logic)), operatorsToFilter).includes(item);
        case 'normal-range':
            return getFilteredBase(NormalRangeVarLogic.filter(logic => !unusedInSubTerms.includes(logic)), operatorsToFilter).includes(item);
        default:
            return true;
    }
};
export const validateLeftHandBaseExists = (leftHand) => {
    const variable = ModuleFE_Variable.cache.unique(leftHand?.id);
    const expression = ModuleFE_Expression.cache.unique(leftHand?.id);
    return exists(expression) || exists(variable) || leftHand?.type === 'atom';
};
export const updateExpressionString = (labelSwaps, expression) => {
    let stringExpression = expression;
    labelSwaps.forEach(labelSwap => {
        const placeholder1 = `{{sub1-${Math.random()}}}`;
        const placeholder2 = `{{sub2-${Math.random()}}}`;
        stringExpression = stringExpression.replace(labelSwap.oldLabel, placeholder1);
        stringExpression = stringExpression.replace(labelSwap.newLabel, placeholder2);
        stringExpression = stringExpression.replace(placeholder1, labelSwap.newLabel);
        stringExpression = stringExpression.replace(placeholder2, labelSwap.oldLabel);
    });
    return stringExpression;
};
export const CollectLabelSwaps = (newItemsOrder, oldOrder) => {
    return newItemsOrder.reduce((swapArray, currentValue, _index) => {
        if (currentValue.label === oldOrder[_index].label)
            return swapArray;
        const swap = { oldLabel: currentValue.label, newLabel: oldOrder[_index].label };
        if (swapArray.some(_swap => arrayIncludesAll(_values(_swap), _values(swap))))
            return swapArray;
        swapArray.push(swap);
        return swapArray;
    }, []);
};
//# sourceMappingURL=utils.js.map